import { OrderButton } from "@omni/components/components/Product/ECommerce/components/orderButton/orderButton";

export const OrderButtonComponent = () => {
    return (
        <OrderButton.Button
            color={"primary"}
            fullWidth={true}
        />
    );
};
